import { SMART_SENSOR_DCU } from '../constants';
import { getInitialStartDate, getInitialEndDate } from 'sharedComponents/TimeSelectorRow/helpers';
import { DownloadLogsReportingPeriod, DownloadLogsTextFields } from './constants';

export const getInitialDownloadLogsFormState = () => ({
    logTypes: [],
    reportTypes: [],
    severityTypes: [],
    organizationId: null,
    ...DownloadLogsTextFields.reduce((formState, field) => ({ ...formState, [field?.key]: '' }), {}),
    dateSelection: {
        from: getInitialStartDate(DownloadLogsReportingPeriod.PRESELECTED_DAYS),
        to: getInitialEndDate()
    }
});

export const isDownloadLogsFormValid = (formState) =>
    !!(formState?.dateSelection?.from && formState?.dateSelection?.to);

export const buildDownloadLogsPayload = (tabType, formState) => ({
    eventSource: tabType,
    timestampFrom: formState?.dateSelection?.from,
    timestampTo: formState?.dateSelection?.to,
    severityCodes: (tabType === SMART_SENSOR_DCU ? formState?.logTypes : formState?.severityTypes) || [],
    organizationId: formState?.organizationId ?? undefined,
    reportType: tabType === SMART_SENSOR_DCU ? formState?.reportTypes || [] : [],
    ...DownloadLogsTextFields
        .filter((field) => field?.appliesTo?.includes(tabType))
        .reduce((payload, field) => ({ ...payload, [field?.payloadKey]: formState?.[field?.key] || undefined }), {})
});

export const formatCountText = (value) => value === null || value === undefined ? '--' : String(value);

const BYTES_PER_MB = 1024 * 1024;

// Shows up to 2 decimal places, but only when the value actually has a fractional part
// (e.g. 19.50 MB, 0.18 MB) - whole numbers (e.g. 50 MB, 0 MB) are shown without decimals.
export const formatSizeText = (sizeInBytes) => {
    if (sizeInBytes === null || sizeInBytes === undefined) {
        return '--';
    }
    const mbValue = (sizeInBytes / BYTES_PER_MB).toFixed(2);
    return `${mbValue.endsWith('.00') ? Number.parseInt(mbValue, 10) : mbValue} MB`;
};

export const formatDownloadLimitText = (downLoadLimitInBytes, placeholder) =>
    downLoadLimitInBytes === null || downLoadLimitInBytes === undefined ? placeholder : formatSizeText(downLoadLimitInBytes);

export const formatMaxFileCountText = (maxFileCountForDownload, placeholder) =>
    maxFileCountForDownload === null || maxFileCountForDownload === undefined ? placeholder : formatCountText(maxFileCountForDownload);

export const isFileCountLimitExceeded = (checkResult) =>
    checkResult?.maxFileCountForDownload !== null && checkResult?.maxFileCountForDownload !== undefined &&
    checkResult?.numberOfFiles > checkResult?.maxFileCountForDownload;

// Default download filename used when saving the returned zip file to disk.
export const buildDownloadLogsFileName = () => `GatewayEventLogs_${Date.now()}.zip`;
